import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isVip: false,
    // 放大状态
    zoomState: 0,
    license: {},
  },
  mutations: {
    setZoomState(state, zoom) {
      state.zoomState = zoom || 0;
    },
    setIsVip(state, isVip) {
      state.isVip = isVip;
    },
    setLicense(state, license) {
      state.license = license;
    },
  },
  actions: {
    fetchUserLicense({ commit }) {
      let token = localStorage.getItem("token");
      if (!token) return;
      let data = {
        token: token,
      };
      axios({
        url: "https://api.kuaixunda.cn/api/license",
        method: "get",
        params: data,
      }).then(({ data }) => {
        if (data.code == 0) {
          commit("setLicense", data.data);
          if (data.data.status == 1) {
            // expiry: "2024-10-29 09:57:59"
            // expiry_day: 0
            // permanent: 0
            // points: 0
            // soft_edition: 1
            // status: 2
            // tokens: 0
            commit("setIsVip", true);
          }
        }
      });
    },
  },
  modules: {},
});

